import type {Result, UseCase} from 'framework';
import type {AssistantError} from '../../domain/errors';
import type {ConversationId} from '../../domain/conversation-id.value-object';
import type {AssistantRepository} from '../ports/assistant.repository';

export class DeleteConversation implements UseCase<[ConversationId], void> {
  constructor(private readonly repository: AssistantRepository) {}

  execute(id: ConversationId): Promise<Result<void, AssistantError>> {
    return this.repository.delete(id);
  }
}
